export default __webpack_public_path__ + "static/media/check.64b6e6f7.svg";